import { InjectionToken, Type } from "@angular/core";
import type { GenericListManagerComponent } from "./generic-list-manager.component";

/**
 * The component class that renders a nested generic-list-manager.
 *
 * The custom field types of generic-field-editor render a list manager inside the form of a
 * list manager. They resolve the class through this token and render it with
 * `NgComponentOutlet`, so that no file under generic-field-editor imports
 * generic-list-manager.component.ts. The app root provides the token.
 */
export const GENERIC_LIST_MANAGER = new InjectionToken<Type<GenericListManagerComponent>>(
    "GENERIC_LIST_MANAGER",
);
